import { render, staticRenderFns } from "./Arrival_broadcast.vue?vue&type=template&id=90703500&"
import script from "./Arrival_broadcast.vue?vue&type=script&lang=js&"
export * from "./Arrival_broadcast.vue?vue&type=script&lang=js&"
import style0 from "./Arrival_broadcast.vue?vue&type=style&index=0&id=90703500&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports